export const OUTGOING_BRIDGE_KIND = {
    SAME_VARIABLE: 'sameVariable',
    DIFFERENT_VARIABLES: 'differentVariables',
} as const;

export const OUTGOING_BRIDGE_LABELS = {
    [OUTGOING_BRIDGE_KIND.SAME_VARIABLE]: 'Same Variable',
    [OUTGOING_BRIDGE_KIND.DIFFERENT_VARIABLES]: 'Different Variables',
} as const;

export const SAME_VARIABLE_BRIDGE_NAME = {
    EBITDA: 'EBITDA',
    NET_INCOME: 'Net Income',
    OPERATING_INCOME: 'Operating Income',
    GROSS_PROFIT: 'Gross Profit',
    REVENUE: 'Revenue',
    EBIT: 'EBIT',
    EBT: 'EBT',
    FREE_CASH_FLOW: 'Free Cash Flow',
    EPS: 'EPS',
    EPS_BASIC: 'EPS - basic',
    EPS_DILUTED: 'EPS - diluted',
    EPS_BASIC_AND_DILUTED: 'EPS - basic and diluted',
    FFO: 'FFO',
    EBITDAR: 'EBITDAR',
    OPERATING_CASH_FLOW: 'Operating Cash Flow',
    INTEREST_INCOME: 'Interest Income',
    OTHER: 'Other',
    NET_INCOME_ATTRIBUTABLE_TO_SHARE_HOLDERS: 'Net Income attributable to Shareholders',
} as const;

export const DIFFERENT_VARIABLES_BRIDGE_NAME = 'x';
